<template>
  <v-menu :min-width="450" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="mx-2" icon v-on="on">
        <v-icon>mdi-palette</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(g, gidx) in gradients"
        :key="gidx"
        @click="$emit('input', g)"
      >
        <div class="h-row gradient-option">
          <div
            v-for="(s, sidx) in g.slice(1)"
            :key="sidx"
            :style="`backgroundColor: ${s}`"
          />
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { all } from './heatmap-gradients'

export default {
  props: {
    value: {}
  },
  data() {
    return {
      gradients: all
    }
  }
}
</script>

<style lang="sass">
.gradient-option
  height: 20px
  > div
    height: 100%
    flex-grow: 1
</style>
